export enum GdprEmailBodyTag {
  SENDER_NAME= '[Sender name]',
  RECIPIENT_NAME= '[Recipient name]',
  CONTACT_EMAIL= '[Contact email]',
  EMAIL_SIGNATURE= '[Email signature]',
  GDPR_SITE_LINK= '[GDPR site link]'
}
